module.exports = __webpack_public_path__ + "media/social/link-website@2x-c1469f87.png";